/**
 * Session-aware axios instance.
 * Automatically injects X-Session-ID header from session manager on every request.
 * Includes a request timeout to prevent hanging calls from blocking the UI.
 */
import axios from 'axios';
import { getSessionId } from '../utils/session';

const api = axios.create({
  timeout: 10000, // 10s timeout — prevents hanging requests from blocking Promise.allSettled
});

api.interceptors.request.use((config) => {
  const sessionId = getSessionId();
  if (sessionId) {
    config.headers['X-Session-ID'] = sessionId;
  }
  return config;
});

export default api;
